import { render, staticRenderFns } from "./c-table-header.vue?vue&type=template&id=b0a16542&scoped=true"
import script from "./c-table-header.vue?vue&type=script&lang=js"
export * from "./c-table-header.vue?vue&type=script&lang=js"
import style0 from "./c-table-header.vue?vue&type=style&index=0&id=b0a16542&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a16542",
  null
  
)

export default component.exports